module.exports = __webpack_public_path__ + "static/12-06cee3e6087b7f86f03f48f5d7847a5c.jpeg";